<template>
  <div class="sixthPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">ABOUT US</span>
      <span class="front">服务企业</span>
    </div>
    <div class="pageBody">
      <div v-for="(item,index) in companyLogos" :key="index">
        <img :src="item">
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "sixthPage",
  data() {
    return {
      companyLogos: [],
    };
  },
  mounted() {
    this.getAllImgs();
  },
  methods: {
    getAllImgs: function () {
      for (let i = 1; i <= 71; i++) {
        let name = "/static/imgs/sixthPage/" + i + ".png";
        this.companyLogos.push(name);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.sixthPage {
  margin: 0 0 0px 0;
  background-color: #fff;
  padding: 140px 0;
}

.head {
  text-align: center;

  img {
    margin-left: -130px;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    z-index: 0;
    opacity: 0.2;
  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}

.pageBody {
  margin-top: 50px;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-around;
  img {
    padding: 0x 3px;
    max-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sixthPage.vue